<template>
      <div>
        <HomeSlider></HomeSlider>
        <div class="container">
          <div class="row direction-column">
            <div class="telegram-bot-info">
              <img src="@/assets/images/logo.png" width="100">
              Daimi güncel giriş için Telegram Botunu takip et!
              <a href="https://t.me/BenimduyuruBot" target="_blank" class="button primary">Takip Et</a>
            </div>
            <AmusnetJackpot></AmusnetJackpot>
            <UpcomingEvents v-if="$user()"></UpcomingEvents>
            <EgtDigitalJackpot></EgtDigitalJackpot>
            <br>
          </div>
        </div>
        <div class="container">
            <!-- <MobileHomeNavs v-if="isMobile"/> -->
            <!-- <HomeSports/> -->
            <!-- <HomePay/>
            <HomeCasino/> -->
            <!-- <MobileDownload/> -->
        </div>
        <SpecialTemplate/>
			</div>
</template>

<script>
  import AmusnetJackpot from '../components/Slot/AmusnetJackpot';
  import PragmaticJackpot from '../components/Slot/PragmaticJackpot';
  import HomeSlider from '../components/Homepage/Slider';
  import MobileDownload from '../components/Homepage/MobileDownload';
  import HomeSports from '../components/Homepage/Sports';
  import HomePay from '../components/Homepage/Pay';
  import HomeCasino from '../components/Homepage/Casino';
  import MobileShortCut from '../components/Common/Header/MobileShortCut';
  import MobileHomeNavs from '../components/Homepage/MobileHomeNavs';
  import SpecialTemplate from '../components/Homepage/SpecialTemplate';
  export default{
    name:'Homepage',
    data(){
      return{

      }
    },
    computed:{
    },
    created(){
    },
    components:{
      MobileShortCut,
      HomeSlider,
      MobileDownload,
      HomeSports,
      HomePay,
      HomeCasino,
      SpecialTemplate,
      PragmaticJackpot,
      AmusnetJackpot,
      MobileHomeNavs
    }
  }
</script>